// 环境管理路由
import Layout from "@/layout";

const environmentRoute = [
    {
        path: '/ambient',
        component: Layout,
        redirect: '/ambient/ambentList',
        name: 'ambient',
        meta: {
          title: '环境管理',
          icon: 'icon-environment',
          roles: ['ROLE_STAFF']
        },
        children: [
          {
            path: 'ambentList',
            component: () => import('@/views/ambient/ambentList'),
            name: 'ambentList',
            meta: {
              title: '冰箱',
              icon: 'IOTtubiao_huabanfuben'
            }
          },
          {
            path: 'addAmbient/:id',
            name: 'addAmbient',
            component: () => import('@/views/ambient/addAmbient'),
            meta: {
              title: '添加冰箱',
              icon: 'form'
            },
            hidden: true
          },
          {
            path: 'ambExcel/:id',
            name: 'ambExcel',
            component: () => import('@/views/ambient/ambExcel'),
            meta: {
              title: '导入',
              icon: 'form'
            },
            hidden: true
          },
          {
            path: 'ambientLook/:id',
            name: 'ambientLook',
            component: () => import('@/views/ambient/ambientLook'),
            meta: {
              title: '查看',
              icon: 'form'
            },
            hidden: true
          },
          {
            path: 'testAreaList',
            component: () => import('@/views/ambient/testAreaList'),
            name: 'testAreaList',
            meta: {
              title: '实验区',
              icon: 'IOTtubiao_huabanfuben-2'
            }
          },
          {
            path: 'addTestArea/:id',
            name: 'addTestArea',
            component: () => import('@/views/ambient/addTestArea'),
            meta: {
              title: '添加实验区',
              icon: 'form'
            },
            hidden: true
          },
          {
            path: 'testAreaExcel/:id',
            name: 'testAreaExcel',
            component: () => import('@/views/ambient/testAreaExcel'),
            meta: {
              title: '导入',
              icon: 'form'
            },
            hidden: true
          },
          {
            path: 'testAreaLook/:id',
            name: 'testAreaLook',
            component: () => import('@/views/ambient/testAreaLook'),
            meta: {
              title: '查看',
              icon: 'form'
            },
            hidden: true
          }
        ]
      }
];
export default environmentRoute;


// WEBPACK FOOTER //
// ./src/router/modules/environmentManagement.js